import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core';

import { roundTimeStore } from '../../../store';

const Timer = observer(() => {
  const { time } = roundTimeStore;
  const { duration } = roundInfoStore;
  const radius = 12.5;
  const circumference = 2 * Math.PI * radius;

  return (
    <>
      {time ? (
        <div className='svg-holder'>
          <svg
            className='circle-chart'
            height='100%'
            viewBox='0 0 33.83098862 33.83098862'
            width='100%'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle
              className='circle-chart__background'
              cx='16.91549431'
              cy='16.91549431'
              fill='#1d2135'
              fillOpacity='0.8'
              r='14'
              stroke='none'
              strokeWidth='1.5'
            />
            <circle
              className='round-loader circle-chart__circle'
              cx='16.91549431'
              cy='16.91549431'
              fill='none'
              r='12.5'
              stroke='#000000'
              strokeOpacity='0.65'
              strokeLinecap='round'
              strokeWidth='1.1'
              strokeDasharray='100'
              strokeDashoffset='200'
            />
            <circle
              className='round-loader circle-chart__circle'
              cx='16.91549431'
              cy='16.91549431'
              fill='none'
              r='12.5'
              stroke='#ffd560'
              strokeLinecap='round'
              strokeWidth='1.1'
              strokeDasharray={circumference}
              strokeDashoffset={-(circumference - circumference * (time / duration))}
            />
            <linearGradient id='gradient'>
              <stop className='start-g-color' offset='0%' stopColor='#1f3c72' stopOpacity='0.4' />
              <stop offset='100%' stopColor='#1f3c72' stopOpacity='1' />
            </linearGradient>
          </svg>
          <span>{time}</span>
        </div>
      ) : (
        <></>
      )}
    </>
  );
});

export default Timer;
